import { render, staticRenderFns } from "./VendorDetailModal.vue?vue&type=template&id=7bca5f80"
import script from "./VendorDetailModal.vue?vue&type=script&lang=js"
export * from "./VendorDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports